export enum TiltProtection {
    ANTITILT_ANGLE = "ANTITILT_ANGLE",
    STIFFENING_PLANKING = "STIFFENING_PLANKING"
}